// ============================================================
// Portfolio photo-wall galleries.
// Placeholder images below are from Lorem Picsum (picsum.photos), seeded
// so each URL is stable across reloads — swap `src` for real photos
// whenever ready; everything else (masonry layout, expand/collapse)
// keeps working unchanged. Mixed portrait/landscape/square sizes on
// purpose, to preview how the masonry wall handles varied aspect ratios.
// ============================================================

// 图片托管在公开的 website_assets 仓库，走 raw 直链
const ASSETS_LOCAL = process.env.PUBLIC_URL + '/figures';

const ASSETS =
  'https://raw.githubusercontent.com/carolinge/website_assets/main/portfolio/failure-simulation';

export const galleries = [
  {
    key: 'simulation-accidents',
    // justified = 每行等高、左右撑满（Flickr 那种），靠下面的 ar 分配宽度
    layout: 'justified',
    label: 'Simulation accidents',
    images: [
      { id: 'sa-1', ar: 834 / 434, src: `${ASSETS}/bonds-in-structured-proteins.jpg`, caption: 'Bonds in structured proteins' },
      { id: 'sa-2', ar: 273 / 266, src: `${ASSETS}/dandelion-wrong-initial-coordinate.png`, caption: 'Dandelion — when you set the wrong initial coordinate' },
      { id: 'sa-3', ar: 717 / 339, src: `${ASSETS}/dragon-interaction-too-strong.png`, caption: 'Dragon — when interaction is too strong for phase separation' },
      { id: 'sa-4', ar: 741 / 317, src: `${ASSETS}/flames-3d-coordinates-processed-wrong.jpg`, caption: 'Flames — when some 3D coordinates are processed wrong' },
      { id: 'sa-5', ar: 183 / 149, src: `${ASSETS}/g3bp1-little-flowers.png`, caption: 'G3BP1 小花花' },
      { id: 'sa-6', ar: 333 / 160, src: `${ASSETS}/grilled-wheat-gluten-alignment-wrong.png`, caption: 'Grilled wheat gluten — when alignment went wrong' },
      { id: 'sa-7', ar: 1641 / 859, src: `${ASSETS}/hydrogel-wrong-interaction.png`, caption: 'Hydrogel with wrong interaction' },
    ],
  },
  {
    key: 'talks-posters',
    // grid3：一行三张、点击放大。和 justified 那栏不同，这里是等宽网格。
    layout: 'grid3',
    label: 'Talks & Posters',
    images: [
      {
        id: 'tp-dpg2026',
        src: `${ASSETS_LOCAL}/poster-dpg2026.jpg`,
        full: `${ASSETS_LOCAL}/poster-dpg2026-full.jpg`,
        caption: 'Phase separation in chemically reacting systems with charged components — DPG Meeting 2026, Dresden',
      },
      // 下面是早先用来预览排版的 Lorem Picsum 占位图，有真图之后先收起来，
      // 需要凑满一行再放回来即可。
      // { id: 'tp-1', src: 'https://picsum.photos/seed/tp01/500/700', caption: 'DPG Meeting 2026, Dresden' },
      // { id: 'tp-2', src: 'https://picsum.photos/seed/tp02/700/480', caption: 'Physical Biology Circle Meeting, Lisbon' },
      // { id: 'tp-3', src: 'https://picsum.photos/seed/tp03/600/600', caption: 'EMBL Symposium, Heidelberg' },
      // { id: 'tp-4', src: 'https://picsum.photos/seed/tp04/450/680', caption: 'National Conference on Biological Condensates, Shanghai' },
      // { id: 'tp-5', src: 'https://picsum.photos/seed/tp05/700/460', caption: 'Soft Matter and Biological Physics, Xi\'an' },
      // { id: 'tp-6', src: 'https://picsum.photos/seed/tp06/550/760', caption: 'Hünfeld Workshop 2026' },
      // { id: 'tp-7', src: 'https://picsum.photos/seed/tp07/680/500', caption: 'HFLN English Academic Forum, Hefei' },
      // { id: 'tp-8', src: 'https://picsum.photos/seed/tp08/500/500', caption: 'Poster session' },
    ],
  },
  {
    key: 'art',
    label: 'Art',
    images: [
      { id: 'art-1', src: 'https://picsum.photos/seed/art01/500/650' },
      { id: 'art-2', src: 'https://picsum.photos/seed/art02/700/500' },
      { id: 'art-3', src: 'https://picsum.photos/seed/art03/600/800' },
      { id: 'art-4', src: 'https://picsum.photos/seed/art04/750/500' },
      { id: 'art-5', src: 'https://picsum.photos/seed/art05/500/500' },
      { id: 'art-6', src: 'https://picsum.photos/seed/art06/650/480' },
      { id: 'art-7', src: 'https://picsum.photos/seed/art07/480/650' },
      { id: 'art-8', src: 'https://picsum.photos/seed/art08/700/460' },
    ],
  },
];
